module.exports = "/_next/static/images/BoxImage-ce63740f7d4e4e6b3c0094b8a7ca45be.jpg";